import { type TDelayState } from 'src/components/duration-input-fields/duration-input-fields.component'

export const DOCUMENT_DEFAULT_DELAY: TDelayState = { days: 0, hours: 0, minutes: 15 }
